import { Link, useParams, useNavigate } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import { useState, useEffect } from "react";
import DeleteModal from "../../../components/deleteModal/DeleteModal";

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from "../../../components/basics/Preloading";

const SnappMenuToppings = () => {
  const { branchId, unitId, categoryId, menuId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [selectedToppings, setSelectedToppings] = useState([]);
  const [gridFilter, setGridFilter] = useState({
    snappMenuId: menuId,
    size: 20,
    part: 1,
    title: "",
    total: 0,
    parts: 0,
  });
  const [snappSecurity, setSnappSecurity] = useState({
    vendorCode: "",
    snappToken: "",
  });
  const [formModel, setFormModel] = useState({
    snappMenuId: menuId,
    snappToppingId: 0,
    vendorCode: "",
    snappToken: "",
  });
  const [formModels, setFormModels] = useState({
    snappMenuId: menuId,
    snappToppingIds: [],
    vendorCode: "",
    snappToken: "",
  });
  const [toppings, setToppings] = useState([]);
  const [toppingFilter, setToppingFilter] = useState({
    branchId: branchId,
    unitId: unitId,
    title: "",
    snappMenuId: menuId,
  });

  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const mapModel = (model) => {
    console.log({ "model:::": model });
    formModel.snappMenuId = model.snappMenuId;
    formModel.snappToppingId = model.snappToppingId;
    formModel.vendorCode = snappSecurity.vendorCode;
    formModel.snappToken = snappSecurity.snappToken;
    formModels.snappMenuId = model.snappMenuId;
    formModels.snappToppingIds = model?.snappToppingIds || [];
    formModels.vendorCode = snappSecurity.vendorCode;
    formModels.snappToken = snappSecurity.snappToken;
    setFormModel({ ...formModel });
    setFormModels({ ...formModels });
  };

  const getGridData = async (showLoading) => {
    if (showLoading) setLoading(true);
    const response = await apiMethod.getSnappMenuToppings(
      gridFilter.snappMenuId,
      gridFilter.title,
      gridFilter.part,
      gridFilter.size
    );
    if (showLoading) setLoading(false);
    if (methods.showApiErrors(response)) {
      gridFilter.total = response.total;
      gridFilter.parts = methods.calcPageParts(response.total, gridFilter.size);
      setGridFilter({ ...gridFilter });
      setGridData(response.data);
    }
  };

  const getToppings = async (showLoading) => {
    if (showLoading) setLoading(true);

    const response = await apiMethod.findToppingsForMenu(
      toppingFilter.branchId,
      toppingFilter.unitId,
      toppingFilter.title,
      toppingFilter.snappMenuId
    );

    if (showLoading) setLoading(false);
    if (methods.showApiErrors(response)) {
      setToppings(response.data);
    }
  };

  const setSnappToken = async () => {
    const response = await apiMethod.getSnappToken(branchId, unitId);
    if (!methods.showApiErrors(response)) return false;
    snappSecurity.snappToken = response.data.token;
    snappSecurity.vendorCode = response.data.clientId;
    setSnappSecurity(snappSecurity);
    setFormModel(formModel);
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getGridData(false);
      await setSnappToken();
      await getToppings(false);
      setLoading(false);
    };
    bindData();
  }, [branchId]);

  const resetForm = () => {
    mapModel({
      snappMenuId: menuId,
      snappToppingId: 0,
      vendorCode: formModel.vendorCode,
      snappToken: formModel.snappToken,
    });
    setShowModal(false);
    setShowDeleteModal(false);
  };

  const getItemInfo = async (id) => {
    setLoading(true);
    const response = await apiMethod.getToppingInfo(id);
    if (!methods.showApiErrors(response)) return false;

    mapModel(response.data);
    setShowModal(true);
    setLoading(false);
  };

  const normalizeModel = () => {
    formModel.snappToken = snappSecurity.snappToken;
    formModel.vendorCode = snappSecurity.vendorCode;
    formModels.snappToken = snappSecurity.snappToken;
    formModels.vendorCode = snappSecurity.vendorCode;
    setFormModel({ ...formModel });
    setFormModels({ ...formModels });
  };

  const createItem = async () => {
    normalizeModel();
    if (!isValidForm()) return false;

    setLoading(true);

    try {
      const resp = await apiMethod.createTopping(formModel);

      if (!methods.showApiErrors(resp)) return false;

      await getGridData();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowModal(false);
    }
  };

  const addTopping = async (item) => {
    formModel.snappToppingId = item.id;
    setFormModel({ ...formModel });

    if (!isValidForm()) return false;

    setLoading(true);
    var resp = await apiMethod.addToppingToMenu(formModel);
    setLoading(false);
    if (methods.showApiErrors(resp)) {
      resetForm();
      getGridData();
    }
  };

  const addGroupTopping = async () => {
    setLoading(true);
    var resp = await apiMethod.addBulkyToppingToMenu(formModels);
    setLoading(false);
    if (methods.showApiErrors(resp)) {
      resetForm();
      getGridData();
    }
  };

  const deleteItem = async () => {
    if (!isValidForm()) return false;

    setLoading(true);
    const resp = await apiMethod.removeToppingFromMenu(formModel);
    setLoading(false);

    if (!methods.showApiErrors(resp)) return false;

    setShowDeleteModal(false);
    await getGridData();
    return true;
  };

  const isValidForm = () => {
    var errors = [];
    if (methods.isNullOrEmptyString(formModel.snappMenuId === 0)) {
      errors.push("منو باید انتخاب شده باشد.");
    }
    if (methods.isNullOrEmptyString(formModel.snappToppingId === 0)) {
      errors.push("تاپینگ باید انتخاب شده باشد.");
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }

    return true;
  };

  const resetFilters = () => {
    gridFilter.snappMenuId = menuId;
    gridFilter.title = "";
    gridFilter.size = 20;
    gridFilter.part = 1;
    setGridFilter({ ...gridFilter });
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const callPager = async (i) => {
    setLoading(true);
    gridFilter.part = i;
    setGridFilter({ ...gridFilter });
    await getGridData();
    setLoading(false);
  };

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (gridFilter.parts < gridFilter.part + 1) {
        return false;
      }
      callPager(gridFilter.part + 1);
    } else {
      if (gridFilter.part === 1) {
        return false;
      }
      callPager(gridFilter.part - 1);
    }
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= gridFilter.parts; i++) {
      pages.push(
        <li
          key={i}
          className={
            gridFilter.part === i ? "page-item active mx-1" : "page-item mx-1"
          }
        >
          <a
            className="page-link circular-pagination"
            onClick={() => {
              callPager(i);
            }}
          >
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const resetSearchFilter = () => {
    toppingFilter.branchId = branchId;
    toppingFilter.unitId = unitId;
    toppingFilter.title = "";
    setToppingFilter({ ...toppingFilter });
  };

  const clearSearchFilters = async () => {
    setLoading(true);
    resetSearchFilter();
    await getToppings();
    setLoading(false);
  };

  const openNewForm = async () => {
    resetForm();
    await getToppings(true);
    setShowModal(true);
  };

  const closeModal = () => {
    resetForm();
    setShowModal(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const selectَSanpToDelete = (item) => {
    formModel.snappToppingId = item.snappToppingId;
    setFormModel(formModel);
    setShowDeleteModal(true);
  };

  const handleToppingMenu = (event) => {
    const { value, checked } = event.target;

    setFormModels((prev) => {
      const currentToppings = Array.isArray(prev.snappToppingIds)
        ? prev.snappToppingIds
        : [];

      let updatedToppings;

      if (checked) {
        updatedToppings = [...currentToppings, value];
      } else {
        updatedToppings = currentToppings.filter((id) => id !== value);
      }
      return { ...prev, snappToppingIds: updatedToppings };
    });
  };

  const selectAllTopping = () => {
    const allToppingIds = toppings.map((item) => item.id);
    setFormModels((prev) => {
      return { ...prev, snappToppingIds: allToppingIds };
    });
  };

  console.log({ "formModels:::": formModels });

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div>
              <Link
                to={`/sale/${branchId}/snappManager/${unitId}/${categoryId}/SnappMenus`}
                className="d-none d-lg-block text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link
                  to={`/sale/${branchId}/snappManager`}
                  className="link back-link"
                >
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                تاپینگ های محصول
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p> تاپینگ های محصول</p>
            </div>
            <div className="salemain">
              <div className="salesearchsection">
                <div className="row g-1">
                  <div className="col-12 col-md-6 col-lg-4">
                    <label htmlFor="funit" className="form-label">
                      عنوان
                    </label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={gridFilter.title}
                        onChange={(e) => {
                          setGridFilter({
                            ...gridFilter,
                            title: e.target.value,
                            part: 1,
                          });
                        }}
                      />
                      <button
                        type="button"
                        className="btn btn-purple me-1"
                        onClick={searchItem}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-info"
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className="col-12 col-md-2 col-lg-4"></div>
                  <div className="col-12 col-md-4">
                    <div className="createButton">
                      <button
                        onClick={() => {
                          openNewForm();
                        }}
                        className="btn btn-outline-purple custome-btn"
                        type="button"
                      >
                        <span className="align-middle d-inline-block">
                          افزودن تاپینگ
                        </span>{" "}
                        <i className="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-responsive saletable">
                <table className="table table-striped table-md ">
                  <thead className="align-middle">
                    <tr>
                      <th scope="col vertical-center" width="20px">
                        ردیف
                      </th>
                      <th scope="col vertical-center">عنوان</th>
                      <th scope="col vertical-center">قیمت</th>
                      <th scope="col vertical-center">هزینه ظرف</th>
                      <th scope="col vertical-center" width="100px">
                        عملیات
                      </th>
                    </tr>
                  </thead>
                  <tbody className="align-middle">
                    {gridData.map((item, index) => (
                      <tr key={item.id}>
                        <th scope="row">
                          {(gridFilter.part - 1) * gridFilter.size + index + 1}
                        </th>
                        <td>{item.title}</td>
                        <td>{methods.addNumSeperator(item.price)}</td>
                        <td>{methods.addNumSeperator(item.containerPrice)}</td>
                        <td>
                          <button
                            onClick={() => selectَSanpToDelete(item)}
                            className="btn btn-sm btn-outline-danger"
                            type="button"
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {gridFilter.parts > 1 && (
                  <nav aria-label="Page navigation example" className="mt-5">
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPart(false);
                          }}
                        >
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItems()}
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPart(true);
                          }}
                        >
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  const Modal = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">ایجاد / ویرایش منوی اسنپ</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-6">
                  <label htmlFor="funit" className="form-label">
                    جستجو در منوهای‌دسته
                  </label>
                  <div className="hstack">
                    <input
                      id="searchInput"
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: "rtl", textAlign: "right" }}
                      value={toppingFilter.title}
                      onChange={(e) => {
                        toppingFilter.title = e.target.value;
                        setToppingFilter({ ...toppingFilter });
                      }}
                    />
                    <button
                      type="button"
                      className="btn btn-purple me-1"
                      onClick={() => {
                        getToppings();
                      }}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-info"
                      onClick={() => {
                        clearSearchFilters();
                      }}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div className="border rounded mt-4">
                <p className="bg-light rounded-top p-3">انتخاب منوهای دسته</p>
                <div className="table-responsive saletable m-3">
                  <table className="table table-striped table-md align-middle">
                    <thead className="">
                      <tr>
                        <th scope="col vertical-center" width="20px">
                          ردیف
                        </th>
                        <th scope="col vertical-center">عنوان</th>
                        <th scope="col vertical-center">دسته بندی</th>
                        <th scope="col vertical-center" width="50px">
                          عملیات
                        </th>
                      </tr>
                    </thead>
                    <tbody className="">
                      {toppings.map((item, index) => (
                        <tr key={item.id}>
                          <th scope="row">{index + 1}</th>
                          <td>
                            <div>
                              <input
                                className="form-check-input"
                                style={{ border: "1px solid #867b7b" }}
                                type="checkbox"
                                value={item.id}
                                id={item.id}
                                onChange={handleToppingMenu}
                              />
                              <label
                                class="form-check-label ps-2"
                                for={item.id}
                              >
                                {item.title}
                              </label>
                            </div>
                          </td>
                          <td>{item.categoryTitle}</td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-sm btn-purple"
                              onClick={() => addTopping(item)}
                            >
                              افزودن
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="d-flex align-items-center justify-content-end">
                    <button
                      type="button"
                      className="btn btn-sm btn-success py-2"
                      onClick={addGroupTopping}
                    >
                      افزودن موارد انتخاب شده
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {renderItems()}
      {showModal && Modal()}
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDeleteModal}
          deleteItem={deleteItem}
          text={"دسته‌بندی"}
        />
      )}
    </>
  );
};

export default SnappMenuToppings;
